var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-item",style:({ alignItems: _vm.valign, flexDirection: _vm.halign })},[(_vm.routerLink)?_c('router-link',{attrs:{"to":_vm.routerLink}},[_c('div',{staticClass:"media-item__image",class:[
        'media-item__image--image--' + _vm.imageSize,
        'media-item__image--gap--' + _vm.gapSize
      ],style:({ backgroundImage: 'url(' + _vm.src + ')' })})]):_c('div',{staticClass:"media-item__image",class:[
      'media-item__image--image--' + _vm.imageSize,
      'media-item__image--gap--' + _vm.gapSize
    ],style:({ backgroundImage: 'url(' + _vm.src + ')' })}),_vm._v(" "),_c('div',{staticClass:"media-item__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }